module.exports = __webpack_public_path__ + "img/to-detail-arrow.fc148166.svg";